import type { NetworkKpis } from "@cryptors/api-client";
import { Paper, Stack, Typography } from "@mui/material";

const fmt = (n: number) => new Intl.NumberFormat("fr-FR").format(n);

type RankingRows = NetworkKpis["topCollections"];

const Ranking = ({
  title,
  rows,
  displayId = false,
}: {
  title: string;
  rows: RankingRows;
  displayId?: boolean;
}) => (
  <Paper sx={{ p: 2, minWidth: 320, flex: 1 }} elevation={1}>
    <Typography variant="caption" color="text.secondary">
      {title}
    </Typography>
    {rows.length === 0 ? (
      <Typography variant="body2" color="text.secondary" mt={2}>
        Aucune donnée
      </Typography>
    ) : (
      <Stack gap={1} mt={2}>
        {rows.map((row, index) => (
          <Stack
            key={row.id}
            direction="row"
            justifyContent="space-between"
            gap={2}
          >
            <Typography variant="body2">
              {index + 1}. {row.name}
              {displayId ? ` (#${row.id})` : ""}
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {fmt(row.captures)}
            </Typography>
          </Stack>
        ))}
      </Stack>
    )}
  </Paper>
);

interface NationalCollectionsTopSectionProps {
  data: NetworkKpis;
}

export const NationalCollectionsTopSection = ({
  data,
}: NationalCollectionsTopSectionProps) => (
  <Stack gap={2}>
    <Typography variant="h6">TOP 5 des collections de CitC</Typography>
    <Stack direction="row" gap={2} flexWrap="wrap">
      <Ranking
        title="Top 5 national de captures par collection"
        rows={data.topCollections}
      />
      <Ranking
        title="Top 5 national de captures par œuvre"
        rows={data.topCryptors}
        displayId
      />
    </Stack>
  </Stack>
);
